import { Location } from "history";
import { createOverviewLink } from "src/utils/internalLinksParsing";

const doUrlsMatch = (Loc1: Location, Loc2: Location): boolean => {
  if (Loc1.pathname !== Loc2.pathname) return false;
  return true;
};

const isLocationCurrentPage = (
  testedLocation: Location,
  currentPageLocation: Location
): boolean => doUrlsMatch(testedLocation, currentPageLocation);

const isLocationEditPageForCurrentDetail = (
  testedLocation: Location,
  currentPageLocation: Location
): boolean => {
  const detailLocation = {
    ...currentPageLocation,
    pathname: currentPageLocation.pathname.replace("detail", "edit"),
  };

  return doUrlsMatch(testedLocation, detailLocation);
};

const isLocationCreatePageForCurrentDetail = (
  testedLocation: Location
): boolean => {
  const pathSliced = testedLocation.pathname.split("/");

  return pathSliced.includes("create");
};

const isLocationLoginPage = (testedLocation: Location): boolean =>
  testedLocation.pathname.startsWith("/login");

// valid = not current detail, not corresponding detail, not login page
const isLocationValid = (
  testedLocation: Location,
  currentPageLocation: Location
): boolean => {
  if (isLocationCurrentPage(testedLocation, currentPageLocation)) {
    return false;
  }

  if (isLocationEditPageForCurrentDetail(testedLocation, currentPageLocation)) {
    return false;
  }

  if (isLocationCreatePageForCurrentDetail(testedLocation)) {
    return false;
  }

  if (isLocationLoginPage(testedLocation)) {
    return false;
  }

  return true;
};

const getOverviewIdFromQuery = (location: Location) => {
  const query = new URLSearchParams(location.search);
  return query.get("overviewId");
};

const getOverviewTemplateLocation = (location: Location) => {
  const overviewId = getOverviewIdFromQuery(location);

  if (!overviewId) return location;

  return createOverviewLink({ id: Number(overviewId) }) as Location;
};

// Go back logic: Go back, BUT:
// 1. prevent going to login page (pointless, confusing)
// 2. prevent going from detail back to edit (for example after save - bad UX)
// 3. also prevent navigating to already open url (after skipping edit via rule #2 )
// eslint-disable-next-line import/prefer-default-export
export const getGoBackUrl = (
  currentLocation: Location,
  locationHistory: Location[]
): Location => {
  const validLocationFromHistory = locationHistory.find((l) =>
    isLocationValid(l, currentLocation)
  );

  return (
    validLocationFromHistory ?? getOverviewTemplateLocation(currentLocation)
  );
};
